import type { FormValues } from "../index";

export function extractFormValuesFromElement(form: HTMLFormElement): FormValues {
	const formData = new FormData(form);
	const collectedValues: FormValues = {};

	formData.forEach((value, key) => {
		if (key === "" || typeof value !== "string") {
			return;
		}

		const existingValue = collectedValues[key];
		if (typeof existingValue === "string") {
			collectedValues[key] = [existingValue, value];
			return;
		}

		if (Array.isArray(existingValue)) {
			collectedValues[key] = [...existingValue, value];
			return;
		}

		collectedValues[key] = value;
	});

	return collectedValues;
}
